import { queryOptions, useQuery } from '@tanstack/react-query'
import { api } from '@/lib/api-client'
import { QueryConfig } from '@/lib/react-query'

export type ChargebeeSubscriptionWithoutAccount = {
    subscriptionId: string
    status: string
    planId: string
    billingPeriod: number | null
    billingPeriodUnit: string | null
    activatedAt: number | null
    currentTermStart: number | null
    currentTermEnd: number | null
    createdAt: number
    customerId: string
    customerEmail: string
    customerCompany: string
    customerPhone: string
}

export const getChargebeeSubscriptionsWithoutAccounts = (): Promise<ChargebeeSubscriptionWithoutAccount[]> => {
    return api.get('/v2/subscription-reports/chargebee-subscriptions-without-accounts')
}

export const getChargebeeSubscriptionsWithoutAccountsQueryOptions = () => {
    return queryOptions({
        queryKey: ['subscription-reports', 'chargebee-subscriptions-without-accounts'],
        queryFn: () => getChargebeeSubscriptionsWithoutAccounts(),
    })
}

type UseChargebeeSubscriptionsWithoutAccountsOptions = {
    queryConfig?: QueryConfig<typeof getChargebeeSubscriptionsWithoutAccounts>
}

export const useChargebeeSubscriptionsWithoutAccounts = ({ queryConfig }: UseChargebeeSubscriptionsWithoutAccountsOptions = {}) => {
    return useQuery({
        ...getChargebeeSubscriptionsWithoutAccountsQueryOptions(),
        ...queryConfig,
    })
}

